import React from 'react';

const SearchInput = ({ value, onChange, placeholder = 'Search...', className = '' }) => (
  <input
    type="text"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    className={`w-56 min-w-56 max-w-56 shrink-0 px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 ${className}`}
  />
);

export default SearchInput;
